<template>
	<section class="sidebar-profile" @click="select">
		<h2 v-if="!isCollapsed">
			<span :class="[ isCollapsed ? 'sr-only' : '' ]">
				{{ student.NAME }}
			</span>
		</h2>
		<div class="media text-sm">
			<div :class="[isCollapsed ? 'media-full' : 'media-left']">
				<img :src="photoUrl"
						:alt="student.STUDENT_ID"
						class="media-object"
						v-if="$store.state.accessToken !== '' && !!student.STUDENT_RID" />
			</div>
			<div :class="[isCollapsed ? 'sr-only' : 'media-body']">
				<ul class="list-unstyled">
					<li v-for="(school, index) in student.ENROLLMENT" :key="`${school.SCHOOL_ID}_${index}`">
						<strong>Grade:</strong> {{ school.GRADE_LEVEL }}
						<br/>{{ school.SCHOOL_TITLE }}
					</li>
				</ul>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	props: {
		student: {
			type: Object,
			default: function() {
				return {};
			}
		},
		isCollapsed: false,
	},
	computed: {
		photoUrl(){
			return this.student.PHOTO_URL;
		},
	},
	methods: {
		select(){
			this.$store.dispatch('updateSelectedStudentRID', this.student.STUDENT_RID);
		}
	}
}
</script>
